var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41256",
    "data-name": "Group 41256",
    transform: "translate(21736 6056)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15649",
    "data-name": "Rectangle 15649",
    width: 16,
    height: 16,
    transform: "translate(-21736 -6056)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_13-Cancel",
    "data-name": "13-Cancel",
    transform: "translate(-21766.994 -6087)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37047",
    "data-name": "Path 37047",
    d: "M38.994,46a7,7,0,1,1,4.95-2.05A7,7,0,0,1,38.994,46Z",
    transform: "translate(0)",
    fill: "#1564e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37048",
    "data-name": "Path 37048",
    d: "M131.744,133.265l-.059-.062-2.541-2.54-2.6,2.6L125,131.72l2.6-2.6-2.6-2.6,1.544-1.544,2.6,2.6,2.6-2.6,1.544,1.544-2.6,2.6,2.6,2.6Z",
    transform: "translate(-90.15 -90.119)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseCircle);
export default __webpack_public_path__ + "static/media/close-circle.a503a2ed9a4f9edb4a353f8b2fa9ae9c.svg";
export { ForwardRef as ReactComponent };